<div class="quality-booking-container">
  <!-- Embedded mode floating language toggle -->
  @if (isEmbedded) {
    <div class="iframe-lang-toggle">
      @if (translate.getActiveLang() === 'en') {
        <button type="button" (click)="translate.setActiveLang('sv')"
          class="lang-btn" title="Växla språk">
          <img width="24" height="24" src="../../../assets/img/flag-button-round-250-SV.png">
        </button>
      }
      @if (translate.getActiveLang() === 'sv') {
        <button type="button" (click)="translate.setActiveLang('en')"
          class="lang-btn" title="Switch language">
          <img width="24" height="24" src="../../../assets/img/flag-button-round-250-EN.png">
        </button>
      }
    </div>
  }
  <!-- Registration form section - always visible when public=true -->
  @if (showDriveInForm) {
    <div class="drive-in-section">
      <div class="flex-center-mb-25">
        <img class="logo-235-100" [src]="logoUrl" />
      </div>
      <div class="drive-in-header">
        <h2 class="drive-in-title">{{'DRIVE_IN_BOOKING.ENTER_CAR_REG_NUMBER' | transloco }}</h2>
        <p class="info-text">{{'QUALITY_LANDING_PAGE.SKIP_THIS_OPTION' | transloco }}</p>
      </div>
      @if (!registrationEntered) {
        <div class="registration-form">
          <form [formGroup]="driveInForm" class="drive-in-form">
            <mat-form-field appearance="outline" class="registration-field">
              <mat-label>{{'DRIVE_IN_BOOKING.REG_NUMBER' | transloco }}</mat-label>
              <input matInput #registrationInput formControlName="registrationNumber" (input)="regToUpper()"
                placeholder="ABC123" [minlength]="4" [maxlength]="9">
            </mat-form-field>
            <div class="form-buttons">
              <button mat-stroked-button type="button" (click)="clearForm()" class="clear-btn">
                {{'DRIVE_IN_BOOKING.CHANGE' | transloco }}
              </button>
              <button mat-raised-button color="primary" type="button" (click)="saveRegistration()"
                [disabled]="driveInForm.invalid || isLoading" class="save-btn">
                @if (isLoading) {
                  <mat-icon class="spinner">refresh</mat-icon>
                }
                @if (!isLoading) {
                  <span>{{'DRIVE_IN_BOOKING.CONTINUE' | transloco }}</span>
                }
              </button>
            </div>
          </form>
        </div>
      }
      @if (registrationEntered) {
        <div class="registration-confirmed">
          <div class="confirmed-reg">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span class="reg-display">{{'DRIVE_IN_BOOKING.REG_NUMBER' | transloco }}:
              <strong>{{enteredRegistration}}</strong></span>
              <button mat-icon-button (click)="clearForm()" class="edit-btn" matTooltip="Change registration">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            <p class="instruction-text">{{'QUALITY_LANDING_PAGE.CHOOSE_BOOKING_OPTION' | transloco }}:</p>
          </div>
        }
        <div class="divider"></div>
      </div>
    }

    <div class="booking-card">
      @if (!showDriveInForm) {
        <div
          class="flex-center-mb-25">
          <img class="logo-235-100" [src]="logoUrl" />
        </div>
      }

      <div class="main-options">
        <button class="booking-option" (click)="selectTransfer()">
          <mat-icon class="option-icon">directions_bus</mat-icon>
          <span class="option-text">{{'QUALITY_LANDING_PAGE.BOOK_TRANSFER' | transloco}}</span>
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </button>

        <button class="booking-option" (click)="selectShortTermParking()">
          <mat-icon class="option-icon">schedule</mat-icon>
          <span class="option-text">{{'QUALITY_LANDING_PAGE.SHORT_TERM' | transloco}}</span>
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </button>

        <button class="booking-option" (click)="selectFullTermParking()">
          <mat-icon class="option-icon">event</mat-icon>
          <span class="option-text">{{'QUALITY_LANDING_PAGE.PARKING_AND_TRANSFER' | transloco}}</span>
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </button>

        @if (site !== 'aiden') {
          <button class="booking-option" (click)="selectDriveUpBooking()">
            <mat-icon class="option-icon">local_parking</mat-icon>
            <span class="option-text">{{'DRIVE_IN_BOOKING.COMPLETE_DRIVE_IN' | transloco}}</span>
            <mat-icon class="arrow-icon">arrow_forward</mat-icon>
          </button>
        }
      </div>
    </div>
  </div>